export default __webpack_public_path__ + "static/media/(46).db1eb2c1.jpg";